<template>
  <v-main class="fill-height d-flex v-application v-application v-application--is-ltr theme--light">
    <div data-app style="flex: 1 1 auto;
    max-width: 100%;
    position: relative;
display: flex;
flex-direction: column;
height: 100%;">
      <v-row class="m-0" style="flex: 0 0 auto;">
        <v-col sm="3" md="2" xl="2" class="pt-1 pb-0">
        </v-col>
        <v-col class="pt-3 pb-0 text-right" >
          <b-button variant="danger" v-if="currentRaster !== undefined" class="btn-pill font-lg" style="color: white" @click="onDeleteRaster">
            Raster löschen
          </b-button>
          <b-button v-if="saveNeeded" variant="warning" class="btn-pill font-lg ml-2" style="color: white" @click="onCancel">
            Abbrechen
          </b-button>
            <b-button v-if="saveNeeded" variant="success" class="btn-pill font-lg ml-2" style="color: white" @click="onSave">
              Speichern
            </b-button>
            <b-button variant="primary" class="btn-pill font-lg ml-2" style="color: white" v-on:click="onBack">
              &nbsp;Zurück
            </b-button>

        </v-col>
      </v-row>
      <v-row class="m-0">
        <v-col sm="3" md="2" xl="2">
          <!-- Button here -->
          <v-btn
              block
              tile
              color="success"
              v-on:click="onCreateRaster"
              :disabled="saveNeeded"
          >
            <v-icon left>
              mdi-plus
            </v-icon>
            Neues Raster
          </v-btn>
          <v-list style="max-height: 70vh; overflow-y: auto">
            <v-list-item-group
                v-model="currentRasterId"
                color="primary"
                @change="changeRaster"
            >
              <v-list-item
                  v-for="(rast, i) in filteredItems"
                  :key="rast.id"
                  :value="rast.id"
                  :disabled="saveNeeded"
              >
                <v-list-item-content>
                  <v-list-item-title v-text="rast.bezeichnung"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
        <v-col>
          <v-card
              style="width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    min-height: 0;">
            <v-calendar
                ref="calendar"
                v-model="focus"
                color="blue"
                :events="events"
                :weekday-format="myDayFormat"
                :month-format="myMonthFormate"
                type="month"
                :weekdays="weekdayOrder"
                start="2022-08-01"
                end="2022-08-14"
                :class="configNumberWeeks === 2 ? 'calendar-rows-2' : 'calendar-rows-1'"
                @click:day="onDayClicked"
            >
              <template v-slot:day-label="{day, present, month}">
                <div></div>
              </template>
              <template v-slot:event="{ event, timed, eventSummary }" >
                <div  :class="[event.id !== 'created' ? 'clickable' : '', 'v-event-draggable']" :id="event.id">
                  <v-row>
                    <v-col>
                      <div class="v-event-summary" style="color: white; display: block">{{event.name}}</div>
                      <div v-if="event.eventType==='rb'" class="v-event-summary" style="color: white; display: block">Rufbereitschaft</div>
                      <div v-else class="v-event-summary" style="color: white; display: block">{{currentRasterAzra.name}}</div>
                    </v-col>
                  </v-row>
                  <!--component :is="{ render: eventSummary }"></component-->

                </div>
              </template>
            </v-calendar>
          </v-card>
          <v-overlay
              absolute
              :value="currentRaster === undefined"
              style="margin: 12px"
              opacity="0.1"
          >
            <v-row>
              <v-col>
                <!--p class="h3">Bitte wählen Sie zuerst ein Raster aus.</p-->
              </v-col>
            </v-row>
          </v-overlay>
        </v-col>
      </v-row>
      <v-dialog
          v-model="showNewRaster"
          max-width="600px"
          persistent
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Neues Raster anlegen</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                >
                  <v-text-field
                      label="Rastername"
                      counter
                      maxlength="50"
                      v-model="newRasterName"
                  ></v-text-field>
                  <v-select
                      v-model="newRasterAzra"
                      :items="azras"
                      item-text="name"
                      item-value="id"
                      label="Arbeitszeitraster auswählen"
                      hide-details="true"
                      no-data-text="Kein passendes Arbeitszeitraster gefunden."
                  ></v-select>
                </v-col>
              </v-row>

            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="onCancleNewRaster"
            >
              Abbrechen
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="onSubmitNewRaster"
                :disabled="newRasterName.trim() === ''"
            >
              Anlegen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showTimeSelectDialog"
          max-width="500px"
          persistent
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Rufbereitschaft: {{dayName}}, Woche {{weekNumber}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-sheet outlined height="600">
                <v-calendar
                    style="padding-bottom: 25px; padding-top: 25px; border: none"
                    :value="currentDay"
                    ref="calendar_daily"
                    color="primary"
                    type="day"
                    :event-ripple="false"
                    locale="de-DE"
                    interval-minutes="15"
                    :interval-count="24 * 4"
                    :hide-header="true"
                    :short-intervals="false"
                    :interval-format="formatInterval"
                    :interval-height="24"
                    :events="timeSelectionEvents"
                    :event-color="getEventColor"
                    @mousedown:event="startDragTimeline"
                    @mousedown:time="startTimeTimeLine"
                    @mousemove:time="mouseMoveTimeLine"
                    @mouseup:time="endDragTimeLine"
                    @mouseleave.native="cancelDragTimeLine"
                >
                  <template v-slot:event="{ event, timed, eventSummary }">
                    <div class="v-event-draggable">
                      <v-row>
                        <v-col md="9">
                          <component :is="{ render: eventSummary }"></component>
                        </v-col>
                        <v-col v-if="event.eventType === 'rb'" md="3">
                          <v-icon @click="onRbDelete(event)"
                              style="float: right; margin-top: 3px; margin-right: 3px; cursor: pointer"
                              color="white"
                          >
                            mdi-delete
                          </v-icon>

                        </v-col>
                      </v-row>
                    </div>
                    <div
                        v-if="event.eventType === 'rb'"
                        class="v-event-drag-bottom"
                        @mousedown.stop="extendBottomTimeLine(event)"
                    ></div>
                  </template>
                </v-calendar>
              </v-sheet>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-btn
                icon
                large
                color="blue darken-1"
                :disabled="currentDay === '2022-08-01'"
                @click="onSaveRbDay(-1)"
            >
            <v-icon>
              mdi-menu-left-outline
            </v-icon>
            </v-btn>
            <v-btn
                icon
                large
                color="blue darken-1"
                :disabled="currentDay === '2022-08-14'"
                @click="onSaveRbDay(1)"
            >
            <v-icon>
              mdi-menu-right-outline
            </v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                v-on:click.stop="onCancelRbDay"
            >
              Abbrechen
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                v-on:click.st.stop="onSaveRbDay(0)"
            >
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="showDeleteConfirm"
          max-width="450px"
          persistent
      >
        <v-card>
          <v-card-title class="text-h5">
            Raster löschen ?
          </v-card-title>
          <v-card-text>
            Soll das Raster: <b>{{rasterName}}</b> gelöschen werden ?<br>Dies kann nicht rückgängig gemacht werden.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="onCancelDeleteRaster"
            >
              Abbrechen
            </v-btn>
            <v-btn
                color="red darken-1"
                text
                @click="onSubmitDeleteRaster"
            >
              Löschen
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-main>
</template>

<script>
import {Redirect_500, Redirect_Login, Server_URL_ZK} from "@/shared/utils";
import _orderBy from "lodash/orderBy"
import _throttle from "lodash/throttle"
import {getUid} from "@/shared/crypto";

export default {
  name: "Raster",
  data: () => ({
    loader: undefined,
    focus: '',
    weekdayOrder: [1, 2, 3, 4, 5, 6, 0],
    weekdays: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
    months: ["","Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
    monthsLong: ["","Januar", "Februar", "März", "April", "Mai", "Juni", "July", "August", "September", "Oktober", "November", "Dezember"],
    currentMonth: 0,
    currentYear: 0,

    currentRasterId: undefined,
    rasters: [],
    azras: [],

    showNewRaster: false,
    newRasterName: "",
    newRasterAzra: undefined,

    currentRaster: undefined,
    currentRasterAzra: undefined,
    currentRasterDetails: [],
    events: [],

    configNumberWeeks: 2,

    // dayView popup
    showTimeSelectDialog: false,
    timeSelectionEvents: [],
    currentDay: null,
    // currently edited event
    createEventTimeLine: null,
    // start time of currently edited event
    createStartTimeLine: null,
    // end time of draged event
    extendOriginalTimeLine: null,
    // dragging
    dragEventTimeline: null,
    dragStartTimeline: null,

    dayName: "",
    weekNumber: "1",

    // controls
    saveNeeded: false,
    showDeleteConfirm: false,
    rasterName: "",

    modifyDeletes: [],
  }),
  computed: {
    filteredItems() {
      return _orderBy(this.rasters, 'bezeichnung');
    },
  },
  mounted () {
    this.$refs.calendar.updateTimes();
    this.currentMonth = this.$refs.calendar.parsedValue.month;
    this.currentYear = this.$refs.calendar.parsedValue.year;
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.showLoader();
    this.$http.get(
        Server_URL_ZK + '/zk/rufbereitschaft/rasters'
    ).then(this.responseOkGet, this.responseError)
  },
  destroyed() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    window.removeEventListener("resize", this.handleResize);
  },
  watch: {
  },
  methods: {
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    onDeleteRaster() {
      this.showDeleteConfirm = true;
      this.rasterName = this.currentRaster.bezeichnung;
    },
    onSubmitDeleteRaster() {
      this.showLoader();
      this.$http.delete(
          Server_URL_ZK + '/zk/rufbereitschaft/rasters/'+this.currentRasterId
      ).then(this.responseOkDelete, this.responseError)
      this.onCancelDeleteRaster();
    },
    onCancelDeleteRaster() {
      this.showDeleteConfirm = false;
      this.rasterName = "";
    },
    responseOkDelete(response) {
      this.hideLoader();
      if (response.status === 200) {
       let i = -1;
        for (let j = 0; j < this.rasters.length; j++) {
          if (this.rasters[j].id === this.currentRasterId) {
            i = j;
            break
          }
        }
        if (i !== -1) {
          this.rasters.splice(i, 1)
        }
        this.currentRaster = undefined;
        this.currentRasterId = undefined;
        this.currentRasterAzra = undefined;
        this.currentRasterDetails = [];
        this.events = [];
      } else {
        console.log(response)
        window.location = Redirect_500;
      }
    },
    responseOkGet(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.rasters = response.body.rasters;
        this.azras = response.body.azras;
        if (this.azras === null) {
          this.azras = [];
        }
      } else {
        window.location = Redirect_500;
      }
    },

    responseError(response) {
      console.log(response);
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    responseOkGetRaster(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.currentRaster = response.body.raster;
        if (this.currentRasterId !== this.currentRaster.id) {
          this.rasters.push(this.currentRaster);
          this.currentRasterId = this.currentRaster.id;
        }
        if (response.body.raster_detail === null) {
          this.currentRasterDetails = [];
        } else {
          this.currentRasterDetails = response.body.raster_detail;
        }
        this.currentRasterAzra = undefined;
        if (this.currentRaster.az_raster !== "") {
          let azraBisId = this.currentRaster.az_raster.replace("AZRA-", "");
          for (let i = 0; i < this.azras.length; i++) {
              if (this.azras[i].bis_id.padStart(6, "0") === azraBisId) {
                this.currentRasterAzra = this.azras[i];
                break;
              }
          }
        }
        this.createEvents();
      } else {
        window.location = Redirect_500;
      }
    },
    changeRaster(rasterId) {
      if (rasterId !== undefined) {
        this.showLoader();
        this.$http.get(
            Server_URL_ZK + '/zk/rufbereitschaft/rasters/'+rasterId
        ).then(this.responseOkGetRaster, this.responseError)
      } else {
        this.currentRaster = undefined;
        this.currentRasterAzra = undefined;
        this.currentRasterDetails = [];
        this.events = [];
      }
    },

    myDayFormat(d) {
      return this.weekdays[d.weekday]
    },
    myMonthFormate(d) {
      return this.months[d.month]
    },
    onCreateRaster() {
      this.showNewRaster = true;
    },
    onCancleNewRaster() {
      this.newRasterName = "";
      this.newRasterAzra = undefined;
      this.showNewRaster = false;
    },
    onSubmitNewRaster() {
        let req = {
          name: this.newRasterName,
          azra: this.newRasterAzra === undefined ? "" : this.newRasterAzra
        }
      this.showLoader();
      this.$http.post(
          Server_URL_ZK + '/zk/rufbereitschaft/rasters', req
      ).then(this.responseOkGetRaster, this.responseError)
      this.onCancleNewRaster();
    },
    // helpers
    getEventColor (event) {
      const rgb = parseInt(event.color.substring(1), 16)
      const r = (rgb >> 16) & 0xFF
      const g = (rgb >> 8) & 0xFF
      const b = (rgb >> 0) & 0xFF

      return event === this.dragEventTimeline
          ? `rgba(${r}, ${g}, ${b}, 0.7)`
          : event === this.createEventTimeLine
              ? `rgba(${r}, ${g}, ${b}, 0.7)`
              : event.color
    },
    calculateEvents() {
      let events = [];
      for (let i = 0; i < this.currentRasterDetails.length; i++) {
            let start = this.currentRasterDetails[i].startIntervallDate
            let end = this.currentRasterDetails[i].endIntervallDate
            let hoursStart = this.currentRasterDetails[i].startIntervallDate.getHours();
            let minutesStart = this.currentRasterDetails[i].startIntervallDate.getMinutes();
            let hoursEnd = this.currentRasterDetails[i].endIntervallDate.getHours();
            let minutesEnd = this.currentRasterDetails[i].endIntervallDate.getMinutes();
            if (hoursEnd === 0) {
              hoursEnd = 24;
            }

            let name = hoursStart.toString().padStart(2, "0") + ":" +
                minutesStart.toString().padStart(2, "0")+ " - " +
                hoursEnd.toString().padStart(2, "0") + ":" +
                minutesEnd.toString().padStart(2, "0");
            let color = "#ea5324"
            let date = `2022-08-${this.currentRasterDetails[i].startIntervallDate.getDate().toString().padStart(2, "0")}`;
            events.push({
              id: this.currentRasterDetails[i].id,
              name: name,
              start: start,
              end: end,
              color: color,
              timed: true,
              startMinutes: hoursStart * 60 + minutesStart,
              endMinutes: hoursEnd * 60 + minutesEnd,
              duration: (hoursEnd * 60 + minutesEnd) - (hoursStart * 60 + minutesStart),
              eventType: "rb",
              date: date,
            })

      }
      // add azra:
      if (this.currentRasterAzra) {
        let timeMap = ["time_mon", "time_tue", "time_wed", "time_thu", "time_fri", "time_sat", "time_sun"]
        for (let i = 0; i < 14; i++) {
          let workTime = this.currentRasterAzra[timeMap[i%7]];
          if (workTime === "00:00-00:00") {
            continue;
          }
          let workStart = workTime.split("-")[0]
          let workEnd = workTime.split("-")[1]
          let day = (i+1).toString().padStart(2, "0");
          let start = new Date(`2022-08-${day}T${workStart}:00`)
          let end = new Date(`2022-08-${day}T${workEnd}:00`)
          let date = `2022-08-${day}`;
          let name = workStart + " - " + workEnd
          let hoursStart = parseInt(workStart.split(":")[0]);
          let minutesStart = parseInt(workStart.split(":")[1]);
          let hoursEnd = parseInt(workEnd.split(":")[0]);
          let minutesEnd = parseInt(workEnd.split(":")[1]);
          if (hoursEnd === 0) {
            hoursEnd = 24;
          }
          let color = "#b2ea24"
          events.push({
            id: "AZRA-"+i.toString(),
            name: name,
            start: start,
            end: end,
            color: color,
            timed: true,
            startMinutes: hoursStart * 60 + minutesStart,
            endMinutes: hoursEnd * 60 + minutesEnd,
            duration: (hoursEnd * 60 + minutesEnd) - (hoursStart * 60 + minutesStart),
            eventType: "azra",
            date: date,
          })
        }
      }
      this.events = events;
      this.$nextTick(this.scaleEvents);
    },
    handleResize() {
      if (this.timeout)
        clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.scaleEvents();
      }, 50); // delay
    },
    scaleEvents() {
      if (this.currentRaster === undefined || this.events.length === 0) {
        return;
      }
      let t = this.$refs.calendar.$refs.events;
      for (let i = 0; i < t.length; i++) {
        try {
          // first check which event this is
          let eventId = "";
          for (let j = 0; j < t[i].children.length; j++) {
            if (t[i].children[j].className === "clickable v-event-draggable") {
              eventId = t[i].children[j].id;
              break;
            }
          }
          // get the event
          if (eventId === "") {
            continue;
          }
          let event = null;
          for (let j = 0; j < this.events.length; j++) {
            if (this.events[j].id === eventId) {
              event = this.events[j];
              break;
            }
          }
          if (event === null) {
            continue
          }
          let dayHeight = t[i].parentElement.clientHeight - 6;
          let percentageStart = event.startMinutes / (60.0*24.0);
          let percentageHeight = event.duration / (60.0*24.0);
          let y = Math.floor(percentageStart * dayHeight) + 3;
          let height = Math.ceil(percentageHeight * dayHeight);
          t[i].style.width = "95%";
          t[i].style.position = "absolute";
          t[i].style.top = `${y}px`;
          t[i].style.height = `${height}px`;
          t[i].classList.add("clickable");
          if (event.date !== t[i].dataset.date) {
            t[i].classList.add("hide")
          } else {
            t[i].classList.remove("hide")
          }

        } catch (e) {
          console.log(e)
        }
      }
    },
    createEvents() {
      // first remap the rasterDetailEntries to 01.08.22 - 28.08.22 (4 weeks interval starting with monday)
      let daysToAdd = -1;
      for (let i = 0; i < this.currentRasterDetails.length; i++) {
        // add start and end date fields
        this.currentRasterDetails[i].startIntervallDate = Date.parse(this.currentRasterDetails[i].start_intervall);
        this.currentRasterDetails[i].endIntervallDate = Date.parse(this.currentRasterDetails[i].ende_intervall);
        if (daysToAdd === -1) {
          // check which date this corresponds to
          let dayOfWeek = (new Date(this.currentRasterDetails[i].startIntervallDate)).getDay();
          if (dayOfWeek === 0) {
            // count from 1:mon -> 7:sun
            dayOfWeek = 7
          }
          let correctStartDate = new Date('2022-08-0'+dayOfWeek.toString());
          daysToAdd = this.dateDiffInDays(new Date(this.currentRasterDetails[i].startIntervallDate), correctStartDate);
        }
        this.currentRasterDetails[i].startIntervallDate = this.addDays(this.currentRasterDetails[i].startIntervallDate, daysToAdd);
        this.currentRasterDetails[i].endIntervallDate = this.addDays(this.currentRasterDetails[i].endIntervallDate, daysToAdd);
      }
      this.calculateEvents()
    },
    dateDiffInDays(a, b) {
      const _MS_PER_DAY = 1000 * 60 * 60 * 24;
      // Discard the time and time-zone information.
      const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
      const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

      return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    },
    addDays(date, days) {
      let result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },
    onDayClicked(d) {
      // first get the existing events
      let validEvents = [];
      for (let i = 0; i < this.events.length; i++) {
        if (this.events[i].date === d.date) {
          validEvents.push({
            id: this.events[i].id,
            name: this.events[i].eventType === "rb" ? "Rufbereitschaft" : this.currentRasterAzra.name,
            start: this.events[i].start,
            end: this.events[i].end,
            color: this.events[i].color,
            timed: true,
            eventType: this.events[i].eventType,
          })
        }
      }
      this.currentDay = d.date;
      this.timeSelectionEvents = validEvents;
      this.modifyDeletes = [];
      let timeMap = ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"]
      this.dayName = timeMap[(d.day-1)%7]
      if (d.day > 7) {
        this.weekNumber = 2;
      } else {
        this.weekNumber = 3;
      }
      this.showTimeSelectDialog = true;
      this.$nextTick(() => {
        setTimeout(() => this.$refs.calendar_daily.scrollToTime('07:00'), 150);
      });
    },
    formatInterval(a) {
      if (a.minute === 0) {
        return a.time;
      }
    },
    startDragTimeline({event, timed}) {
      if (event && timed && event.eventType !== "rb") {
        return
      }
      if (event && timed) {
        this.dragEventTimeline = event;
        this.dragTime = null;
        this.extendOriginalTimeLine = null;
      }
    },
    startTimeTimeLine (tms) {
      const mouse = this.roundTime(this.toTime(tms));
      let realTime = this.toTime(tms);
      if (this.dragEventTimeline && this.dragTime === null) {
        const start = this.dragEventTimeline.start;
        this.dragTime = realTime - start;
        return;
      }
      for (let i = 0; i < this.timeSelectionEvents.length; i++) {
        let blocked = this.timeSelectionEvents[i];
        if ((realTime < blocked.end)  &&  (realTime > blocked.start)) {
          return;
        }
      }

      this.createStartTimeLine = this.roundTime(mouse)
      this.createEventTimeLine = {
        id: getUid(),
        name: `Rufbereitschaft`,
        color: "#ea5324",
        start: this.createStartTimeLine,
        end: this.createStartTimeLine,
        timed: true,
        eventType: "rb",
      };
      this.timeSelectionEvents.push(this.createEventTimeLine)
    },
    extendBottomTimeLine (event) {
      this.createEventTimeLine = event
      this.createStartTimeLine = event.start
      this.extendOriginalTimeLine = event.end
    },
    mouseMoveTimeLine (tms) {
      const mouse = this.toTime(tms)
      if (this.dragEventTimeline && this.dragTime !== null) {
        const start = this.dragEventTimeline.start
        const end = this.dragEventTimeline.end
        const duration = end - start
        const newStartTime = mouse - this.dragTime
        const newStart = this.roundTime(newStartTime)
        const newEnd = newStart + duration;
        if (this.formatDate(newStart).split("T")[0] !== this.currentDay) {
          return;
        } else if (this.formatDate(newEnd).split("T")[0] !== this.currentDay &&
            ((new Date(newEnd)).getMinutes() !== 0 || (new Date(newEnd)).getHours() !== 0)) {
          return;
        }
        let isBlocked = false;
        for (let i = 0; i < this.timeSelectionEvents.length; i++) {
          let e = this.timeSelectionEvents[i];
          if (e.id !== this.dragEventTimeline.id && ((newStart < e.end)  &&  (newEnd > e.start))) {
             isBlocked = true;
             break
          }
        }
        if (isBlocked) {
          return;
        }
        this.dragEventTimeline.start = newStart
        this.dragEventTimeline.end = newEnd
      } else if (this.createEventTimeLine && this.createStartTimeLine !== null) {
        const mouseRounded = this.roundTime(mouse, false)
        const min = Math.min(mouseRounded, this.createStartTimeLine)
        const max = Math.max(mouseRounded, this.createStartTimeLine)
        for (let i = 0; i < this.timeSelectionEvents.length; i++) {
          let blocked = this.timeSelectionEvents[i];
          if (this.createEventTimeLine.id !== blocked.id && (min < blocked.end)  &&  (max > blocked.start)) {
            return;
          }
        }
        this.createEventTimeLine.start = min
        this.createEventTimeLine.end = max
      }
    },
    endDragTimeLine () {
      if (this.createEventTimeLine !== null && this.createEventTimeLine.start === this.createEventTimeLine.end) {
        const i = this.timeSelectionEvents.indexOf(this.createEventTimeLine)
        if (i !== -1) {
          this.timeSelectionEvents.splice(i, 1)
        }
      }
      this.createEventTimeLine = null
      this.createStartTimeLine = null
      this.extendOriginalTimeLine = null
      this.dragTime = null;
      this.dragEventTimeline = null;
    },
    cancelDragTimeLine () {
      this.createEventTimeLine = null
      this.createStartTimeLine = null
      this.extendOriginalTimeLine = null
      this.dragTime = null;
      this.dragEventTimeline = null;
    },
    roundTime (time, down = true) {
      const roundTo = 15 // minutes
      const roundDownTime = roundTo * 60 * 1000

      return down
          ? time - time % roundDownTime
          : time + (roundDownTime - (time % roundDownTime))
    },
    toTime (tms) {
      return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
    },
    onRbDelete(event) {
      const i = this.timeSelectionEvents.indexOf(event)
      if (i !== -1) {
        this.modifyDeletes.push(this.timeSelectionEvents.splice(i, 1)[0]);

      }
      if (this.createStartTimeLine && this.createEventTimeLine.id === event.id) {
        this.cancelDragTimeLine();
      }
    },
    onSaveRbDay(next) {
      if (this.createStartTimeLine) {
        this.cancelDragTimeLine();
      }
      console.log(this.modifyDeletes)
      // first check if there were changes at all
      let allFound = true;
      for (let i = 0; i < this.timeSelectionEvents.length; i++) {
        let curCheck = this.timeSelectionEvents[i];
        let found = false;
        for (let j = 0; j < this.events.length; j++) {
          if (this.events[j].id === curCheck.id) {
              found = new Date(this.events[j].start).getTime() === new Date(curCheck.start).getTime() &&
                  new Date(this.events[j].end).getTime() === new Date(curCheck.end).getTime()
            break
          }
        }
        if (!found) {
          allFound = false;
          break
        }
      }
      for (let i = 0; i < this.modifyDeletes.length; i++) {
        if (!allFound) {
          break
        }
        let curCheck = this.modifyDeletes[i];
        for (let j = 0; j < this.events.length; j++) {
          if (this.events[j].id === curCheck.id) {
            allFound = false;
            break
          }
        }
      }
      this.modifyDeletes = [];
      if (!allFound) {
        this.saveNeeded = true;
        let eventsNew = [];
        for (let i = 0; i < this.events.length; i++) {
          if (this.events[i].date !== this.currentDay) {
            eventsNew.push(this.events[i]);
          }
        }
        for (let i = 0; i < this.timeSelectionEvents.length; i++) {
          let e = this.timeSelectionEvents[i];
          let start = new Date(e.start);
          let end = new Date(e.end);
          let hoursStart = start.getHours();
          let minutesStart = start.getMinutes();
          let hoursEnd = end.getHours();
          let minutesEnd = end.getMinutes();
          if (hoursEnd === 0) {
            hoursEnd = 24;
          }
          let name = hoursStart.toString().padStart(2, "0") + ":" +
              minutesStart.toString().padStart(2, "0") + " - " +
              hoursEnd.toString().padStart(2, "0") + ":" +
              minutesEnd.toString().padStart(2, "0");
          let color = e.eventType === "rb" ? "#ea5324" : "#b2ea24";
          let date = `2022-08-${start.getDate().toString().padStart(2, "0")}`;
          eventsNew.push({
            id: e.id,
            name: name,
            start: start,
            end: end,
            color: color,
            timed: true,
            startMinutes: hoursStart * 60 + minutesStart,
            endMinutes: hoursEnd * 60 + minutesEnd,
            duration: (hoursEnd * 60 + minutesEnd) - (hoursStart * 60 + minutesStart),
            eventType: e.eventType,
            date: date,
          })
        }
        this.events = eventsNew;
        this.$nextTick(this.scaleEvents);
      }
      if (next === 0) {
        this.onCancelRbDay();
        return;
      }
      let nextDay = new Date(this.currentDay);
      nextDay.setDate(nextDay.getDate() + next);
      let d = {
        date: this.formatDate(nextDay).split("T")[0],
        day: nextDay.getDate(),
      }
      this.cancelDragTimeLine();
      this.onDayClicked(d);
    },
    onCancelRbDay() {
      this.showTimeSelectDialog = false;
      this.timeSelectionEvents = [];
      this.currentDay = null;
      this.cancelDragTimeLine();
      this.dayName = "";
      this.weekNumber = "1";
      this.modifyDeletes = [];
    },
    onSave() {
      // collect all events with type rb
      let data = [];
      for (let i = 0; i < this.events.length; i++) {
        if (this.events[i].eventType === "rb") {
          data.push(
              {
                start_intervall: new Date(this.events[i].start),
                ende_intervall: new Date(this.events[i].end),
              }
          )
        }
      }
      console.log(data)
      this.showLoader();
      this.$http.post(
          Server_URL_ZK + '/zk/rufbereitschaft/rasters/'+this.currentRasterId, data
      ).then(this.responseOkUpdateRaster, this.responseError)
    },
    responseOkUpdateRaster(response) {
      this.hideLoader();
      if (response.status === 200) {
        this.currentRasterId = undefined;
        this.currentRaster = undefined;
        this.currentRasterAzra = undefined;
        this.currentRasterDetails = [];
        this.events = [];
        this.saveNeeded = false;
      } else {
        console.log(response)
        window.location = Redirect_500;
      }
    },
    onCancel() {
      this.createEvents();
      this.saveNeeded = false;
    },
    onBack() {
      window.history.back();
    },
    formatDate(date) {
      let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-');
    }
  }
}
</script>

<style lang="scss">

.v-calendar .v-event {
  pointer-events: none;
}
.clickable {
  pointer-events: auto !important;
}

.theme--light.v-label {
  color: black;
}


.v-calendar-weekly__head-weekday {
  color: black !important;
  background-color: #e4e5e6 !important;
}
.theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside {
  margin-right: -1px;
}

.soll-ist {
  margin-top: 4px;
}

.soll-ist.zero {
  background-color: rgb(240, 230, 140) !important;
  border-color: rgb(240, 230, 140) !important;
}

.soll-ist.neg {
  background-color: rgb(255, 69, 0)!important;
  border-color: rgb(255, 69, 0)!important;
  color: white;
}

.soll-ist.pos {
  background-color: rgb(1, 109, 3)!important;
  border-color: rgb(1, 109, 3)!important;
  color: white;
}


.hide {
  display: none;
}

</style>

<style scoped lang="scss">

.v-list-item-group .v-list-item--active{
  background-color: #63c2de;
}

.v-event-draggable {
  padding-left: 6px;
}

.v-event-timed {
  user-select: none;
  -webkit-user-select: none;
}

.v-event-drag-bottom {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 4px;
  height: 4px;
  cursor: ns-resize;

  &::after {
    display: none;
    position: absolute;
    left: 50%;
    height: 4px;
    border-top: 1px solid white;
    border-bottom: 1px solid white;
    width: 16px;
    margin-left: -8px;
    opacity: 0.8;
    content: '';
  }

  &:hover::after {
    display: block;
  }
}

.v-radio::v-deep {
  align-self: flex-start;
}

.v-input--is-disabled::v-deep input {
  color: black;
}

.v-radio::v-deep > .v-label {
  margin: 0;
}

//.v-calendar-monthly::v-deep .v-calendar-weekly__week:nth-of-type(1n+4) {display: none;}

.calendar-rows-2::v-deep .v-calendar-weekly__week:nth-of-type(1n+4) {display: none;}
.calendar-rows-1::v-deep .v-calendar-weekly__week:nth-of-type(1n+3) {display: none;}
.v-calendar-monthly::v-deep .v-calendar-weekly__week {
  cursor: pointer !important;
}

.theme--light::v-deep.v-calendar-weekly .v-calendar-weekly__head-weekday {color: black !important;}

</style>
